var $10e8c1ecf47ad433$exports = {};
$10e8c1ecf47ad433$exports = {
    "breadcrumbs": `\u{5E9}\u{5D1}\u{5D9}\u{5DC}\u{5D9} \u{5E0}\u{5D9}\u{5D5}\u{5D5}\u{5D8}`
};


export {$10e8c1ecf47ad433$exports as default};
//# sourceMappingURL=he-IL.mjs.map
